export default __webpack_public_path__ + "static/media/noun-ethereum-4618636.eb213f34.png";